import React, { useState } from "react";
import { TextField, Button, Box } from "@mui/material";

const uncertaintyRanges = [
  { min: -15, max: 0, uncertainty: 0.8 },
  { min: 0, max: 50, uncertainty: 0.65 },
  { min: 50, max: 100, uncertainty: 0.7 },
  { min: 100, max: 120, uncertainty: 0.76 },
  { min: 120, max: 200, uncertainty: 0.94 },
  { min: 200, max: 350, uncertainty: 1.6 },
  { min: 350, max: 500, uncertainty: 2.1 },
];

function IRThermometer() {
  const [inputValue, setInputValue] = useState("");
  const [uncertainty, setUncertainty] = useState("");

  const handleChange = (e) => {
    const value = parseFloat(e.target.value);
    setInputValue(e.target.value);

    if (!isNaN(value)) {
      const match = uncertaintyRanges.find(
        (range) => value >= range.min && value < range.max
      );
      setUncertainty(match ? match.uncertainty.toString() : "Out of range");
    } else {
      setUncertainty("");
    }
  };

  const handleCopy = () => {
    if (uncertainty) {
      navigator.clipboard.writeText(uncertainty);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: "auto",
        mt: 5,
        p: 3,
        boxShadow: 3,
        borderRadius: 2,
        display: "flex",
        flexDirection: "column",
        gap: 2,
      }}
    >
      <TextField
        label="Enter Value (°C)"
        variant="outlined"
        type="number"
        value={inputValue}
        onChange={handleChange}
        fullWidth
      />
      <TextField
        label="Uncertainty (± °C)"
        variant="outlined"
        value={uncertainty}
        InputProps={{
          readOnly: true,
        }}
        fullWidth
      />
      <Button
        variant="contained"
        onClick={handleCopy}
        disabled={!uncertainty || uncertainty === "Out of range"}
      >
        Copy
      </Button>
    </Box>
  );
}

export default IRThermometer;